import React from "react";

const UsericonComponent = () => <div>Usericon</div>;

export default UsericonComponent;
